import { type FC, useState } from "react";
import { useDetectWindowSizeInfo } from "@userFrontend/hooks/useDetectWindowSize";
import { useUserData } from "./useUserData";
import { Presentation } from "./Presentation";

type Props = {
  fetchUrl: string;
  contentName: string;
  name: string;
  link: string;
};

export const UserInformationModal: FC<Props> = ({ fetchUrl, contentName, name, link }) => {
  const { isSP } = useDetectWindowSizeInfo();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { isShowContent, content, isShowTelLink } = useUserData(fetchUrl, isModalOpen, isSP);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleClickMessageButton = () => {
    window.location.href = link;
  };

  return (
    <Presentation
      contentName={contentName}
      content={content}
      isShowContent={isShowContent}
      isModalOpen={isModalOpen}
      openModal={openModal}
      closeModal={closeModal}
      isShowTelLink={isShowTelLink}
      name={name}
      handleClickMessageButton={handleClickMessageButton}
      isSP={isSP}
    />
  );
};
